module.exports = __webpack_public_path__ + "devicon.0f964a72f8fbdf9c8d4e.woff";


//////////////////
// WEBPACK FOOTER
// /home/munkhuu/Desktop/mum/CS572/resume/src/assets/devicons/fonts/devicon.woff?-hdf3wh
// module id = ../../../../../src/assets/devicons/fonts/devicon.woff?-hdf3wh
// module chunks = styles